var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1847 45.9691C10.3373 45.9691 9.59984 45.6554 8.97243 45.028C8.34498 44.4006 8.03125 43.6631 8.03125 42.8157V11.1844C8.03125 10.3369 8.34498 9.59947 8.97243 8.97206C9.59984 8.34461 10.3377 8.03088 11.1859 8.03088H35.546L45.9695 18.4544V42.8145C45.9695 43.6627 45.6558 44.4006 45.0283 45.028C44.4009 45.6554 43.6635 45.9691 42.816 45.9691H11.1847ZM11.1899 43.5029H42.8109C43.0128 43.5029 43.1787 43.438 43.3085 43.3081C43.4383 43.1783 43.5032 43.0125 43.5032 42.8105V19.9435H34.0811V10.4972H11.1899C10.9879 10.4972 10.8221 10.5621 10.6923 10.6919C10.5624 10.8217 10.4975 10.9876 10.4975 11.1895V42.8105C10.4975 43.0125 10.5624 43.1783 10.6923 43.3081C10.8221 43.438 10.9879 43.5029 11.1899 43.5029ZM16.3649 36.5581H37.6359V34.0918H16.3649V36.5581ZM16.3649 19.9082H27.0004V17.4419H16.3649V19.9082ZM16.3649 28.2137H37.6359V25.7474H16.3649V28.2137Z",
    fill: "#92140C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.36b0c56f86ca17209ccd43fc7e747f73.svg";
export { ForwardRef as ReactComponent };